$(document).ready(function () {
    function r() {
        var e = this.parentNode,
            n = e.getElementsByTagName("input"),
            a = parseFloat(n[0].value),
            t = parseFloat(n[1].value);
        if (t < a) {
            var r = t;
            (t = a), (a = r);
        }
        e.getElementsByClassName("rangeValues")[0].innerHTML = "от " + a + " до " + t;
    }

    $(function () {
        const slider = $(".js-range-slider");

        slider.ionRangeSlider({
            onChange: data => {
                $(".rangeFrom").text(data.from === 0 ? 1 : data.from);
                $(".rangeTo").text(data.to);
            }
        });
        // slider.on("change", function () {
        //     var e = $(this),
        //         n = (e.prop("value"), e.data("from")),
        //         a = e.data("to");
        //     $(".rangeFrom").text(n), $(".rangeTo").text(a);
        // });
    });
    (window.onload = function () {
        for (var e = document.getElementsByClassName("range-slider"), n = 0; n < e.length; n++) for (var a = e[n].getElementsByTagName("input"), t = 0; t < a.length; t++) "range" === a[t].type && ((a[t].oninput = r), a[t].oninput());
    });
});
